import BarclaysTransactions from "./BarclaysTransactions.svelte";
import Analytics from "./Analytics.svelte";
import Orders from "./Orders.svelte";
import Order from "./Order.svelte";
import OrdersTable from "./OrdersTable.svelte";
import Styling from "./Styling.svelte";
import Stats from "./Stats/Stats.svelte";
import TopProducts from "./Stats/TopProducts.svelte";
import TopPerformers from "./Stats/StatsTopPerformers.svelte";
import Products from "./Products/Products.svelte";
import Subscriptions from "./Subscriptions/Subscriptions.svelte";
import Product from "./Products/Product.svelte";
import { addNewCategory } from "./Products/ProductCategory.svelte";
import { editProductVariations } from "./Products/ProductVariations.svelte";
import { editProductInventory } from "./Products/ProductInventory.svelte";
import { editProductAdditions } from "./Products/ProductAdditions.svelte";
import { editProductSeo } from "./Products/ProductSeo.svelte";
import Intro from "./Intro.svelte";
import ReviewSettings from './Reviews/Index.svelte';
import ProviderProduct from './Fulfillment/ProviderProduct.svelte';

export let StoreApi = {
  Barclays: {
    listTransactions: (target) => {
      return new BarclaysTransactions({
        target: target
      });
    }
  },
  Analytics: (target) => {
    return new Analytics({
      target: target
    });
  },
  Intro: (target) => {
    return new Intro({
      target: target
    });
  },
  Stats: {
    all: (target, period, funnelId, filters, disabledStats) => {
      return new Stats({
        target: target,
        props: {
          period: period,
          funnelId: funnelId,
          filters: filters || [],
          disabledStats: disabledStats
        }
      });
    }
  },
  Subscriptions: {
    list: (target) => {
      return new Subscriptions({
        target: target,
        props: {}
      });
    }
  },
  Products: {
    listAll: (target, options) => {
      return new Products({
        target: target,
        props: {
          options: options
        }
      });
    },
    addNewProductCategory: (parentCategory, order, then) => {
      addNewCategory(parentCategory, order, then);
    },
    editVariations: (product, onDone) => {
      editProductVariations(product, onDone);
    },
    editInventory: (product, onDone) => {
      editProductInventory(product, onDone);
    },
    editAdditions: (product, onDone) => {
      editProductAdditions(product, onDone);
    },
    editSeo: (product, onDone, onGetDescription) => {
      editProductSeo(product, onDone, onGetDescription);
    },
    edit: (target, options) => {
      return new Product({
        target: target,
        props: options
      });
    }
  },
  Orders: {
    listAll: (target, options) => {
      return new Orders({
        target: target,
        props: {
          options: options
        }
      });
    },
    listFunnelOrders: (target, period, funnelId, filters, options) => {
      return new OrdersTable({
        target: target,
        props: {
          period: period,
          funnel: funnelId,
          filters: filters,
          options: options
        }
      });
    },
    listContactOrders: (target, contactId, options) => {
      return new OrdersTable({
        target: target,
        props: {
          contact: contactId,
          options: options
        }
      });
    },
    listTopProducts: (target, period, funnelId, filters) => {
      return new TopProducts({
        target: target,
        props: {
          period: period,
          funnel: funnelId,
          filters: filters
        }
      });
    },
    listTopPerformers: (target, period, funnelId, filters, options) => {
      return new TopPerformers({
        target: target,
        props: {
          period: period,
          funnel: funnelId,
          filters: filters,
          options: options
        }
      });
    },
    single: (target, id, options) => {
      return new Order({
        target: target,
        props: {
          id: id,
          options: options
        }
      });
    }
  },
  Styling: (target) => {
    return new Styling({
      target: target,
      props: {}
    });
  },
  Reviews: {
    Settings: (target, props) => {
      return new ReviewSettings({ target: target, props: props });
    }
  },
  Fulfillment: {
    ProviderProduct: (target, props) => {
      return new ProviderProduct({ target: target, props: props });
    }
  }
};
